import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const H5Icon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "H5",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.68 29.99a2 2 0 0 0 2-2v-10h9.33v10a2 2 0 1 0 4 0V4.01a2 2 0 1 0-4 0v10H4.67v-10a2 2 0 1 0-4 0V28a2 2 0 0 0 2 2h.01ZM20.67 4.01v6.67a2 2 0 0 0 2 2h4.66v2.66h-4.66a2 2 0 1 0 0 4h6.67a2 2 0 0 0 2-2v-6.67a2 2 0 0 0-2-2h-4.67V5.99h4.66a2 2 0 1 0 0-4h-6.66a2 2 0 0 0-2 2s0 .01 0 .01Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.28 8.64c-.88 0-1.75.17-2.63.54l.75-4.68h6.47V2.28h-8.3l-1.39 9.8.07.05c1.8-1.16 3.43-1.58 4.72-1.58 2.12 0 3.68 1.5 3.68 3.5 0 2.29-1.66 3.5-3.8 3.5-1.53 0-3.21-.71-4.84-2.22h-.05v2.58c1.07.99 2.92 1.85 5.09 1.85 3.24 0 5.94-2.49 5.94-5.69s-2.36-5.44-5.72-5.44ZM16 2.29c-.63 0-1.14.51-1.14 1.14v11.43H2.29V3.43a1.14 1.14 0 1 0-2.28 0v25.14a1.14 1.14 0 1 0 2.28 0V17.14h12.57v11.43a1.14 1.14 0 1 0 2.28 0V3.43c0-.63-.51-1.14-1.14-1.14"
      })
    })
  }));
};
H5Icon.displayName = 'H5Icon';